import React from 'react';
import { getModule } from '@/modules';
import classNames from 'classnames';
import { ModuleBaseModel, ModuleBasePropsModel } from '@/types';

interface ICMSModule {
  module: ModuleBaseModel<ModuleBasePropsModel>;
  className?: string;
  [key: string]: any;
}

const CMSModule = ({ module, className, ...props }: ICMSModule) => {
  let moduleName = module?.moduleName;
  if (moduleName) {
    moduleName = String(moduleName).charAt(0).toUpperCase() + String(moduleName).slice(1);

    const Component = getModule(moduleName);

    if (!Component) {
      console.error(`The Module ${moduleName} has not been created yet.`);
    }

    return Component ? (
      <Component {...module} {...props} />
    ) : (
      <div className={classNames('bg-white text-black', className)}>
        The Module <b>{moduleName}</b> has not been created yet.
      </div>
    );
  }
};

export default CMSModule;
